import React, { useMemo } from 'react';
import { Progress } from 'antd';
import { useAIDiagnoseStore } from '../../store/useAIDiagnoseStore';
import { genStepsBySelectTherapyList } from '../../utils';

import cx from './index.module.scss';

interface Props {}

const ProgressVScreen: React.FC<Props> = () => {
  const currentStep = useAIDiagnoseStore.use.currentStep();
  const { selectTherapyType } = useAIDiagnoseStore.use.formValue();
  const steps = useMemo(() => genStepsBySelectTherapyList(selectTherapyType), [selectTherapyType]);

  return (
    <div className={cx('ProgressVScreen')}>
      <div className={cx('wrapper')}>
        <div className={cx('pre-step', 'pre-step-1', { active: currentStep >= -2 })}></div>
        <div className={cx('pre-step', 'pre-step-2', { active: currentStep >= -1 })}></div>
        <Progress
          className={cx('ant-progress')}
          style={{ width: '100%' }}
          showInfo={false}
          steps={currentStep < -1 ? 1 : steps?.length}
          percent={currentStep < 0 ? 0 : ((currentStep + 1) / steps?.length) * 100}
        />
      </div>
    </div>
  );
};

export default ProgressVScreen;
